// extracted by mini-css-extract-plugin
export default {"slick_slide":"HomeCarousel_slick_slide__gQd4p"};